"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceItemAtIndex = exports.mergeAppendToArray = void 0;
const mergeAppendToArray = (existingArray, newArray, keyFn, appendOrder, appendMergedItems, customAppendFn) => {
    const existingMap = new Map(existingArray.map((item, index) => [keyFn(item), index]));
    const itemsWithUpdates = appendMergedItems
        ? existingArray.filter(i => !newArray.some(j => keyFn(j) === keyFn(i)))
        : [...existingArray];
    const newItems = [];
    newArray.forEach(newItem => {
        const key = keyFn(newItem);
        const existingIndex = existingMap.get(key);
        if (!appendMergedItems && existingIndex !== undefined) {
            itemsWithUpdates[existingIndex] = newItem;
        }
        else {
            newItems.push(newItem);
        }
    });
    let mergedItems;
    switch (appendOrder) {
        case "APPEND":
            mergedItems = [...itemsWithUpdates, ...newItems];
            break;
        case "PREPEND":
            mergedItems = [...newItems, ...itemsWithUpdates];
            break;
        case "CUSTOM":
            if (!customAppendFn) {
                throw new Error("customAppendFn param is mandatory with CUSTOM appendOrder!!!");
            }
            mergedItems = itemsWithUpdates;
            for (const newItem of newItems) {
                mergedItems = customAppendFn(mergedItems, newItem);
            }
            break;
        default:
            throw new Error("Unsupported appendOrder!!!");
    }
    return {
        mergedItems,
        newItems: newItems.filter(i => !existingArray.some(j => keyFn(i) === keyFn(j))),
    };
};
exports.mergeAppendToArray = mergeAppendToArray;
const replaceItemAtIndex = (arr, item, index) => {
    return [...arr.slice(0, index), item, ...arr.slice(index + 1)];
};
exports.replaceItemAtIndex = replaceItemAtIndex;
